import dispatcher from '../others/Dispatcher';

export function updateTickets(tickets) {
    dispatcher.dispatch({
        type: 'UPDATE_ASSIGN_TICKETS',
        body: tickets
    });
}

export function updateFilter(filter) {
    dispatcher.dispatch({
        type: 'UPDATE_ASSIGN_FILTER',
        body: filter
    });
}

export function updateSort(sort) {
    dispatcher.dispatch({
        type: 'UPDATE_ASSIGN_SORT',
        body: sort
    });
}

export function updateMeta(meta) {
    dispatcher.dispatch({
        type: 'UPDATE_ASSIGN_META',
        body: meta
    });
}
export function updateAuthentication(oauth) {
    dispatcher.dispatch({
        type: 'UPDATE_AUTHENTICATION',
        body: oauth
    });
}


// WEBPACK FOOTER //
// ./src/js/actions/AssignmentActions.js